import type { MenuItems } from "@/modules/menu";

import {
  useMenuItemLink,
  useMenuItemLogoutAction,
  useMenuSelectedKeys,
} from "@/modules/menu";

export const useUserDropdownMenu = () => {
  const menuItems: MenuItems = [
    useMenuItemLink("password"),
    useMenuItemLink("language"),
    { type: "divider" },
    useMenuItemLogoutAction(),
  ];

  const { selectedKeys } = useMenuSelectedKeys(menuItems);

  return {
    items: menuItems,
    selectedKeys,
  };
};
